import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '@lib/env';
import { Observable } from 'rxjs';
import { UriBuilder } from 'uribuilder';

@Injectable({ providedIn: 'root' })
export class DemandDeliveryConditionDataService {
    private readonly http = inject(HttpClient);
    private readonly env = inject(EnvService);


    public deleteCondition(demandId: string, supplierCompanyId: string): Observable<void> {
        const url = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'delivery-condition');

        return this.http.delete<void>(url.toString());
    }

    public updateCondition(demandId: string, supplierCompanyId: string, deliveryConditionId: string): Observable<void> {
        const uri: UriBuilder = this.env.getBase('demand', demandId, 'supplier', supplierCompanyId, 'delivery-condition');

        return this.http.post<void>(uri.toString(), {deliveryConditionId});
    }
}
